import { render, staticRenderFns } from "./ModalFormConsultation.vue?vue&type=template&id=ed0b57ce&scoped=true"
import script from "./ModalFormConsultation.vue?vue&type=script&lang=js"
export * from "./ModalFormConsultation.vue?vue&type=script&lang=js"
import style0 from "./ModalFormConsultation.vue?vue&type=style&index=0&id=ed0b57ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0b57ce",
  null
  
)

export default component.exports